import styled from 'styled-components';

export const StyledClientsApiPage = styled.div`
  margin: 20px;
  display: flex;
  flex-direction: column;
  .clients-page__logo {
    width: 42px;
    height: 42px;
  }
  .clients-page__title {
    margin-top: 10px;
    ${({ theme }) => theme.typography.h2};
  }
  .clients-page__data-wrapper {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: first baseline;
    .clients-page__data {
      background: ${({ theme }) => theme.colors.grey6};
      padding: 10px;
      border-radius: 8px;
      border: 1px solid #ddd;
      width: 640px;
      overflow-x: auto;
    }
  }

  .clients-page__label {
    margin-top: 20px;
    ${({ theme }) => theme.typography.h3}
  }
  .clients-page__input-wrapper {
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: baseline;
  }
  .clients-page__autocomplete {
    position: relative;
  }
  .clients-page__input {
    height: 50px;
    width: 340px;
    padding-left: 15px;
    margin-top: 8px;
    border: 2px solid;
    border-radius: 10px;
    border-color: ${({ theme }) => theme.colors.grey3};
    ${({ theme }) => theme.typography.formInput}
    &:focus {
      border-color: ${({ theme }) => theme.colors.green1};
      outline: none;
    }
  }
  .clients-page__suggestions {
    position: absolute;
    z-index: 5;
    top: calc(100% + 4px);
    left: 0;
    width: 340px;
    max-height: 320px;
    overflow-y: auto;
    background: white;
    border: 1px solid ${({ theme }) => theme.colors.grey3};
    border-radius: 8px;
    box-shadow: 0 8px 24px rgb(0 0 0 / 12%);
  }
  .clients-page__suggestion {
    display: block;
    width: 100%;
    padding: 10px 12px;
    border: none;
    background: white;
    color: ${({ theme }) => theme.colors.text1};
    cursor: pointer;
    text-align: left;
    ${({ theme }) => theme.typography.formInput}
    &:hover {
      background: ${({ theme }) => theme.colors.grey6};
    }
  }
  .clients-page__button {
      height: 40px;
      width: 160px;
      border-radius: 10px;
      background-color: ${({ theme }) => theme.colors.green1};
      ${({ theme }) => theme.typography.formButton}
      color: white;
      cursor: pointer;
    }
`;
